import { Box, Text } from "@chakra-ui/react";
import React, { memo, PropsWithChildren } from "react";
import colors from "app/colors";

const FloatingLabel = ({
  children,
  label,
}: PropsWithChildren & { label?: string }) => (
  <Box pos="relative" w="full">
    {children}
    {label && (
      <Text
        backgroundColor={colors.white}
        px={2}
        fontSize={14}
        fontWeight={500}
        color={colors.grayMain}
        pos="absolute"
        top="-7px"
        left="12px"
        zIndex={1}
        lineHeight={1}
      >
        {label}
      </Text>
    )}
  </Box>
);
export default memo(FloatingLabel);
